import { BadgeDollarSign, DatabaseZap, MessageCircleQuestion, Radar } from 'lucide-react'

import type { AuthFeatureItem } from './auth-layout.interface'

export const AUTH_TAGLINE = 'No extra subscriptions. Just ask, research, and rank.'

export const AUTH_FEATURE_LIST: AuthFeatureItem[] = [
  {
    icon: BadgeDollarSign,
    title: '$500/mo worth of tools, built in',
    description:
      'SEMrush, Ahrefs, Lighthouse, site crawling - all included. No separate accounts, no API keys, no extra costs.',
  },
  {
    icon: Radar,
    title: 'Know your market before your competitors do',
    description:
      'Uncover search demand, content gaps, and untapped opportunities across any niche - the kind of research that used to take days and an analyst.',
  },
  {
    icon: DatabaseZap,
    title: 'Real data, not AI guesswork',
    description:
      'Every insight is pulled live from actual search data - not generated from thin air like most "AI SEO tools."',
  },
  {
    icon: MessageCircleQuestion,
    title: 'Just ask what you need',
    description:
      '"Who\'s winning in my niche and why?" or "What content gaps can I exploit?" - get sourced, actionable answers in seconds.',
  },
]
